/** Capability priority (Feature 87): each capability's level and the platform default. */
import { apiGet, apiPut } from '../client.js';
import type {
  CapabilityLevel,
  CapabilityPriorities,
  CapabilityPriority,
  PriorityDefault,
} from '../types.js';

/** The default, and every installed capability's level and running count. */
export function listCapabilityPriorities(): Promise<CapabilityPriorities> {
  return apiGet<CapabilityPriorities>('/api/v1/admin/capability-priorities');
}

/** Give a capability its own level, or `null` to return it to the default. */
export function setCapabilityPriority(
  capabilityId: string,
  level: CapabilityLevel | null,
): Promise<CapabilityPriority> {
  return apiPut<CapabilityPriority>(
    `/api/v1/admin/capability-priorities/${encodeURIComponent(capabilityId)}`,
    { level },
  );
}

export function getPriorityDefault(): Promise<PriorityDefault> {
  return apiGet<PriorityDefault>('/api/v1/admin/platform-settings/capability-priority');
}

/** The level every capability without its own takes. */
export function setPriorityDefault(level: CapabilityLevel): Promise<PriorityDefault> {
  return apiPut<PriorityDefault>('/api/v1/admin/platform-settings/capability-priority', {
    level,
  });
}
